import { BaseComponent } from "../base-component";
import componentStyles from './purchase.css?inline';


export class PurchasePage extends BaseComponent {
  protected styles(): string {
    return componentStyles;
  }

  protected template(): string {
    return `
      <ag-panel>
        <ag-panel-header>
          <h1>Subscribe</h1>
        </ag-panel-header>
        <ag-panel-content>
          <p>Select subscription.</p>
        </ag-panel-content>
      </ag-panel>
    `;
  }
}

customElements.define('purchase-page', PurchasePage);